<template>
  <div>
    <Head />

    <nav class="breadcrumb_box" aria-label="breadcrumb">
      <ol class="breadcrumb container">
        <li class="breadcrumb-item"><router-link to="/">{{ $t('首頁') }}</router-link></li>
        <li class="breadcrumb-item active" aria-current="page">{{ $t('申請進度查詢') }}</li>
      </ol>
    </nav>

    <div class="wrapper list progress_list">
      <svg class="bg"></svg>
      <div class="container">
        <div class="title_box">
          <h1>{{ $t('申請進度查詢') }}</h1>
        </div>
        <ul class="btn_box">
          <li>
            <button class="item_btn" :class="Type == 0 ? 'active' : ''" @click="Type = 0">{{ $t('全部') }}</button>
          </li>
          <li>
            <button class="item_btn" :class="Type == 1 ? 'active' : ''" @click="Type = 1">{{ $t('教職宿舍') }}</button>
          </li>
          <li>
            <button class="item_btn" :class="Type == 2 ? 'active' : ''" @click="Type = 2">{{ $t('學人宿舍') }}</button>
          </li>
          <li>
            <button class="item_btn" :class="Type == 3 ? 'active' : ''" @click="Type = 3">{{ $t('停車位') }}</button>
          </li>
        </ul>
        <div class="list_box show">
          <div class="box" v-for="Apply in Applys" :key="Apply.AId">
            <div class="title">
              <h2><span v-if="Apply.Type == 1">{{ $t('教職宿舍') }}</span><span v-if="Apply.Type == 2">{{ $t('學人宿舍')
                  }}</span><span v-if="Apply.Type == 3">{{ $t('停車位') }}</span> {{ Apply.ApplyId }}</h2>
            </div>
            <div class="text_box">
              <ul class="progress_box">
                <li class="active" v-if="Apply.Status == 0">
                  <div class="img_box">
                    <img src="img/progress_icon1.svg" alt="">
                    <p>{{ $t('審核中') }}</p>
                  </div>
                </li>
                <li class="active" v-if="Apply.Status == 1">
                  <div class="img_box">
                    <img src="img/progress_icon2.svg" alt="">
                    <p>{{ $t('審核通過，等待抽籤中') }}</p>
                  </div>
                </li>
                <li class="active" v-if="Apply.Status == 2">
                  <div class="img_box">
                    <img src="img/progress_icon3.svg" alt="">
                    <p>{{ $t('已錄取') }}</p>
                  </div>
                </li>
                <li class="active" v-if="Apply.Status == 3">
                  <div class="img_box">
                    <img src="img/progress_icon3.svg" alt="">
                    <p>{{ $t('租賃中') }}</p>
                  </div>
                </li>
                <li class="active" v-if="Apply.Status == 9">
                  <div class="img_box">
                    <img src="img/progress_icon3.svg" alt="">
                    <p>{{ $t('已退租') }}</p>
                  </div>
                </li>
                <li class="active" v-if="Apply.Status == 99">
                  <div class="img_box">
                    <img src="img/progress_icon4.svg" alt="">
                    <p>{{ $t('未錄取') }}</p>
                  </div>
                </li>
                <li class="active" v-if="Apply.Status == 999">
                  <div class="img_box">
                    <img src="img/progress_icon4.svg" alt="">
                    <p>{{ $t('審核失敗') }}</p>
                  </div>
                </li>
                <!-- <li :class="Apply.Status == 1 ? 'active' : ''">
                  <div class="img_box">
                    <img src="img/progress_icon2.svg" alt="">
                    <p v-if="Apply.Status == 1">審核通過</p>
                    <p v-else>處理中</p>
                  </div>
                </li>
                <li v-if="Apply.Status == 0 || Apply.Status == 1">
                  <div class="img_box">
                    <img src="img/progress_icon3.svg" alt="">
                    <p>處理中</p>
                  </div>
                </li>
                <li :class="Apply.Status == 2 ? 'active' : ''" v-if="Apply.Status != 99">
                  <div class="img_box">
                    <img src="img/progress_icon3.svg" alt="">
                    <p>已入住</p>
                  </div>
                </li>
                <li :class="Apply.Status == 3 ? 'active' : ''" v-if="Apply.Status != 99">
                  <div class="img_box">
                    <img src="img/progress_icon3.svg" alt="">
                    <p>已入住</p>
                  </div>
                </li>
                <li class="active fail_box" v-if="Apply.Status == 99">
                  <div class="img_box">
                    <img src="img/progress_icon4.svg" alt="">
                    <p>未中籤</p>
                  </div>
                </li> -->
              </ul>
              <div class="text" v-if="Apply.Type == 1">
                <div class="full">
                  <p>{{ $t('申請人') }}</p>
                  <p>{{ Apply.T1_ApplicantName }}</p>
                </div>
                <div class="full">
                  <p>{{ $t('申請時間') }}</p>
                  <p>{{ Apply.CreateTime | timeString("YYYY/MM/DD HH:MM:SS") }}</p>
                </div>
                <div class="full">
                  <p>{{ $t('申請宿舍') }}</p>
                  <p>{{ Apply.StaffLevel.Space == 1 ? $t('單房間') : $t('多房間') }} {{
                    numberToCurrencyNo(Apply.StaffLevel.Price) }}{{ $t('元/月') }}　{{ $t('保證金') }}{{
                      numberToCurrencyNo(Apply.StaffLevel.Deposit) }}{{ $t('元') }}</p>
                </div>
              </div>
              <div class="text" v-if="Apply.Type == 2">
                <div>
                  <p>{{ $t('申請人') }}</p>
                  <p>{{ Apply.T2_ApplyName }}</p>
                </div>
                <div>
                  <p class="basis_60">{{ $t('性別') }}</p>
                  <p>{{ Apply.T2_TenantGender }}</p>
                </div>
                <div class="full">
                  <p>{{ $t('借住日期') }}</p>
                  <p>{{ Apply.T2_StayPeriodStart | timeString("YYYY/MM/DD") }}-{{ Apply.T2_StayPeriodEnd |
                    timeString("YYYY/MM/DD") }}</p>
                </div>
                <div>
                  <p>{{ $t('服務單位') }}</p>
                  <p>{{ Apply.T2_TenantUnit }}</p>
                </div>
                <div>
                  <p class="basis_60">{{ $t('職稱') }}</p>
                  <p>{{ Apply.T2_TenantTitle }}</p>
                </div>
                <div class="full">
                  <p>{{ $t('申請宿舍') }}</p>
                  <p>{{ Apply.ScholarBuilding.Space == 1 ? $t('單房間') : $t('多房間') }} {{ Apply.ScholarBuilding.Name }} {{
                    Apply.ScholarRoom.RoomId }}</p>
                </div>
              </div>
              <div class="text" v-if="Apply.Type == 3">
                <div class="full">
                  <p>{{ $t('申請時間') }}</p>
                  <p>{{ Apply.CreateTime | timeString("YYYY/MM/DD HH:MM:SS") }}</p>
                </div>
                <div class="full">
                  <p>{{ $t('申請人') }}</p>
                  <p>{{ Apply.T3_ApplyName }}</p>
                </div>
                <div class="full">
                  <p>{{ $t('申請車牌') }}</p>
                  <p>{{ Apply.T3_LicensePlate }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="list_box show" v-if="Applys.length == 0">
            <div class="box">
              <div class="none_text">
                <p>{{ $t('查無資料...') }}</p>
              </div>
            </div>
          </div>
        </div>
        <paginate :no-li-surround="false" :page-count="pageAll" :page-range="3" :margin-pages="1"
          :click-handler="loadList" :prev-text="'«'" :next-text="'»'" :prev-link-class="'page-link'"
          :next-link-class="'page-link'" :container-class="'pagination'" :page-class="'page-item'"
          :page-link-class="'page-link'" :active-class="'active'" :hide-prev-next="false" v-if="pageAll > 1">
        </paginate>
      </div>
    </div><!-- wrapper -->

    <Footer />
  </div>
</template>
<script>
import Head from "@/components/Head.vue";
import Footer from "@/components/Footer.vue";

import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

import Paginate from "vuejs-paginate";
Vue.component("paginate", Paginate);

const messages = {
  zh_tw: {
    "首頁": "首頁",
    "申請進度查詢": "申請進度查詢",
    "全部": "全部",
    "教職宿舍": "教職宿舍",
    "學人宿舍": "學人宿舍",
    "停車位": "停車位",
    "審核中": "審核中",
    "審核通過，等待抽籤中": "審核通過，等待抽籤中",
    "已錄取": "已錄取",
    "租賃中": "租賃中",
    "已退租": "已退租",
    "未錄取": "未錄取",
    "審核失敗": "審核失敗",
    "申請人": "申請人",
    "申請時間": "申請時間",
    "申請宿舍": "申請宿舍",
    "單房間": "單房間",
    "多房間": "多房間",
    "元/月": "元/月",
    "保證金": "保證金",
    "元": "元",
    "性別": "性別",
    "借住日期": "借住日期",
    "服務單位": "服務單位",
    "職稱": "職稱",
    "申請車牌": "申請車牌",
    "查無資料...": "查無資料...",
    "請先登入帳號": "請先登入帳號",
  },
  en: {
    "首頁": "Home Page",
    "申請進度查詢": "Application Status Inquiry",
    "全部": "All",
    "教職宿舍": "Faculty & Staff Dormitory",
    "學人宿舍": "Visiting Scholars Dormitory",
    "停車位": "Parking Space",
    "審核中": "Under review",
    "審核通過，等待抽籤中": "Approved and awaiting lottery selection",
    "已錄取": "Accepted",
    "租賃中": "Currently leased",
    "已退租": "Vacated",
    "未錄取": "Not accepted",
    "審核失敗": "Review Unsuccessful",
    "申請人": "Applicant",
    "申請時間": "Application period",
    "申請宿舍": "Dormitory application",
    "單房間": "Single-room",
    "多房間": "Multi-room",
    "元/月": "NT$/month",
    "保證金": "Security Deposit",
    "元": "NT$",
    "性別": "Gender",
    "借住日期": "Move-in date",
    "服務單位": "Department",
    "職稱": "Position Title",
    "申請車牌": "License Plate",
    "查無資料...": "No information available…",
    "請先登入帳號": "Please log in first",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

export default {
  name: "Progress",
  i18n,
  components: {
    Head,
    Footer,
  },
  data() {
    return {
      ProgressData: {},
      Type: 0,
      Applys: [],
      pageAll: 0,
      perPage: 10,
      local: "zh_tw",
    };
  },
  watch: {
    Type(newValue, oldValue) {
      this.loadList(1);
    }
  },
  beforeCreate: function () {
    if (!$cookies.isKey("dormitory_login_token")) {
      Swal.fire({
        title: this.$t("請先登入帳號"),
        icon: "info",
        allowOutsideClick: false,
        heightAuto: false,
        willClose: () => {
          this.$router.push({
            name: "Home",
          });
        },
      });
      return;
    }
  },
  created: function () {
    Vue.axios
      .get(
        this.$store.state.src +
        this.$store.state.subDirectory +
        "/Html/Progress",
        {
          params: { token: $cookies.get("dormitory_login_token") },
        }
      )
      .then((response) => {
        this.ProgressData = response.data;
        this.loadList(1);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    if ($cookies.isKey("dormitory_site_lang")) {
      i18n.locale = $cookies.get("dormitory_site_lang");
      this.local = $cookies.get("dormitory_site_lang");
    } else {
      i18n.locale = "zh_tw";
      this.local = "zh_tw";
    }
  },
  updated: function () {
  },
  methods: {
    loadList: function (page) {
      var that = this;
      $.ajax({
        url:
          this.$store.state.src +
          this.$store.state.subDirectory +
          "/Html/ApplyList",
        type: "post",
        data: {
          Type: that.Type,
          page: page,
          perPage: that.perPage,
          token: $cookies.get("dormitory_login_token"),
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          if (res.status == 1) {
            that.Applys = res.Applys;
            that.perPage = res.perPage;
            that.pageAll = Math.max(Math.ceil(res.total / that.perPage), 1);
            document.body.scrollTop = 0;
          }
        },
      });
    },
    convertDatetimeString(time, format) {
      var date = new Date(
        time.replace(
          /^(\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)$/,
          "$4:$5:$6 $2/$3/$1"
        )
      );
      return moment(date).format(format);
    },
    numberToCurrencyNo(value) {
      if (!value) return 0
      const intPart = Math.trunc(value)
      const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
      let floatPart = ''
      const valueArray = value.toString().split('.')
      if (valueArray.length === 2) {
        floatPart = valueArray[1].toString()
        return intPartFormat + '.' + floatPart
      }
      return intPartFormat + floatPart
    }
  },
};
</script>
